import React from 'react';

const ResourcesUIBox = () => (
  <section style={{
    maxWidth: 1500,
    margin: '48px auto 0 auto',
    padding: '0 24px',
  }}>
    <div style={{
      background: '#0098d0',
      borderRadius: 28,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '19px 19px',
      gap: 32,
      color: '#fff',
      flexWrap: 'wrap'
    }}>
      <div style={{ flex: 1, minWidth: 260 }}>
        <h2 style={{ fontWeight: 600, fontSize: 32, marginBottom: 18 }}>
          Our New UI Improves Your Workflow
        </h2>
        <p style={{ fontSize: 20, marginBottom: 32, lineHeight: 1.6 }}>
          Clearer interfaces = faster decisions. Our latest update makes everyday tasks 30% quicker.
        </p>
        <a
          href="#"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            background: '#fff',
            color: '#0098d0',
            fontWeight: 500,
            fontSize: 20,
            borderRadius: 16,
            padding: '18px 48px',
            textDecoration: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            transition: 'background 0.2s, color 0.2s'
          }}
        >
          See what's new
          <svg style={{ marginLeft: 12 }} width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M13 6l6 6-6 6" stroke="#0098d0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>
      <div style={{ flex: 1.2, minWidth: 320, display: 'flex', justifyContent: 'flex-end' }}>
        <img
          src="/images/resoursed.png"
          alt="Genix UI Updates"
          style={{ width: 600, height: 350, objectFit: 'contain', borderRadius: 24, background: '#0098d0' }}
        />
      </div>
    </div>
  </section>
);

export default ResourcesUIBox; 